export const cssBundleHref = "/build/css-bundle-ES6C6MSD.css";